<!--
 * @Author: 单译 2694138418@qq.com
 * @Date: 2022-08-08 09:39:52
 * @LastEditors: 单译 2694138418@qq.com
 * @LastEditTime: 2022-12-13 15:00:29
 * @FilePath: \music\src\components\dialog\transfer.vue
 * @Description: 
 * 
 * Copyright (c) 2022 by 单译 2694138418@qq.com, All Rights Reserved. 
-->
<template>
    <div>
        <el-dialog :modal-append-to-body="false" custom-class="delCarMusic" title="对公转账"
            :close-on-click-modal="false" :visible.sync="payDialogVisible" width="690px" :before-close="handlePayClose">
            <el-divider></el-divider>
            <div v-if="orderDetail">
                <div class="pay">
                    <div class="payTitle">
                        <p>订单编号：</p>
                        <div class="payInfo hidden">{{ orderDetail.order_id }} <i class="el-icon-copy-document"
                                @click="copy(orderDetail.order_id)" style="margin-left: 9px; "></i>
                        </div>
                    </div>
                </div>
                <div class="pay">
                    <div class="payTitle">
                        <p>歌曲数量：</p>
                        <div class="payInfo hidden">{{ orderDetail.song_num }} <i class="el-icon-copy-document"
                                @click="copy(orderDetail.song_num)" style="margin-left: 9px; "></i>
                        </div>
                    </div>
                </div>
                <div class="pay">
                    <div class="payTitle">
                        <p>账户名称：</p>
                        <div class="payInfo hidden">南京新航道文化传媒有限公司 <i class="el-icon-copy-document"
                                @click="copy('南京新航道文化传媒有限公司')" style="margin-left: 9px; "></i>
                        </div>
                    </div>
                </div>
                <div class="pay">
                    <div class="payTitle">
                        <p>银行账户：</p>
                        <div class="payInfo hidden">125913126210901 <i class="el-icon-copy-document"
                                @click="copy('125913126210901')" style="margin-left: 9px; "></i>
                        </div>
                    </div>
                </div>
                <div class="pay">
                    <div class="payTitle">
                        <p>开户行：</p>
                        <div class="payInfo hidden">招商银行股份有限公司南京江宁支行 <i class="el-icon-copy-document"
                                @click="copy('招商银行股份有限公司南京江宁支行')" style="margin-left: 9px; "></i>
                        </div>
                    </div>
                </div>
                <div class="pay">
                    <div class="payTitle">
                        <p>付款金额：</p>
                        <div class="payInfo hidden">{{ orderDetail.amount }} 元 <i class="el-icon-copy-document"
                                @click="copy(orderDetail.amount)" style="margin-left: 9px; "></i>
                        </div>
                    </div>
                </div>
            </div>
            <div slot="footer" class="dialog-footer payFooter">
                <p> 注意：
                <p> 1.您在转账汇款备注中，请填写您的订单编号，以使运营可以尽快核对到您的付款信息；</p>
                <p>2.您完成银行转账/线下汇款后，请将电子回单凭证和您的账户手机号提供给客服；</p>
                <p> 3.我们将在确认转账后，会立即为您开通对应服务，届时也会有以短信的形式通知您</p>
                </p>
                <div class="consult">
                    <img src="../../assets/home/nochoose.png" alt="">
                    <span  @click="consult">咨询客服</span>
                </div>
            </div>
        </el-dialog>
        <codeVue ref="code"></codeVue>
    </div>
</template>

<script>
import codeVue from '../dialog/code.vue'

export default {
    data() {
        return {
            payDialogVisible: false,
        }
    },
    props: {
        orderDetail: {
            type: Object,
            default: () => { }
        }
    },
    components: {
        codeVue
    },
    methods: {
       async consult() {
            console.log(this.orderDetail);
            let data = await this.$home.noticeOfflinePay({order_id:this.orderDetail.id})
            if(data.code == 200){
                this.$refs.code.paySuccess = true
            }
        },
        handlePayClose() {
            this.payDialogVisible = false
        },
        copy(i) {
            var input = document.createElement("input"); // 创建input对象
            input.value = i; // 设置复制内容
            document.body.appendChild(input); // 添加临时实例
            input.select(); // 选择实例内容
            document.execCommand("Copy"); // 执行复制
            document.body.removeChild(input); // 删除临时实例
            this.$msg('success', '提示', '复制成功！');
        }
    }
}
</script>

<style lang="scss" scoped>
.payFooter {
    font-size: 14px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #999999;
    text-align: left !important;

    .consult {
        margin-top: 20px;
        display: flex;
        align-items: center;
        gap: 6px;

        img {
            width: 32px;
            height: 32px;
        }
    }
}


::v-deep .el-dialog__header {
    padding: 20px 30px;
    padding-bottom: 10px;
}

::v-deep .el-dialog__footer {
    text-align: left;
    padding: 20px 30px;
}

::v-deep .el-dialog__body {
    border-bottom: 1px dashed #AAAAAA;
    margin: 0 30px;
    padding: 0;
    // margin-bottom: 30px;
    padding-bottom: 10px;

    .el-divider--horizontal {
        margin: 14px 0 24px 0;
    }
}

::v-deep .el-dialog__title {
    font-weight: 600;
}

.payTitle {
    display: flex;
    margin-bottom: 20px;

    >p {
        font-size: 14px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: black;
        line-height: 16px;
    }

    >div {
        font-size: 14px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
        line-height: 16px;

        i {
            cursor: pointer;
        }
    }
}
</style>